import { useEffect } from "react";
import useCommonActions from "../../contexts/common/UseCommonActions";
import { useCredentialDefinitionsContext } from "../../contexts/credentialDefinitions/CredentialDefinitionsContext";
import { useSchemasContext } from "../../contexts/schemas/SchemasContext";
import { useUsersContext } from "../../contexts/users/UsersContext";
import { NetworkingServiceErrorType } from "../../core/services/network/NetworkServiceError";
import { notify } from "../../libs/observables/notification";
import { useAuthContext } from "../../contexts/authentication/AuthenticationContext";
import { useCredentialsContext } from "../../contexts/credentials/CredentialsContext";
import { useProofsContext } from "../../contexts/proofs/ProofsContext";
import { useCategoriesContext } from "../../contexts/categories/CategoriesContext";
import { useInvitationsContext } from "../../contexts/invitations/InvitationsContext";
import { useRequestsContext } from "../../contexts/requests/RequestsContext";
import { useIconsContext } from "../../contexts/icons/IconsContext";

export const AppErrorObserver = () => {
  const { authError } = useAuthContext();
  const { schemasError } = useSchemasContext();
  const { categoriesError } = useCategoriesContext();
  const { iconsError } = useIconsContext();
  const { credentialDefinitionsError } = useCredentialDefinitionsContext();
  const { credentialsError } = useCredentialsContext();
  const { proofsError } = useProofsContext();
  const { invitationsError } = useInvitationsContext();
  const { requestsError } = useRequestsContext();
  const { usersError } = useUsersContext();
  const { dispatchClearErrors } = useCommonActions();

  useEffect(() => {
    const error =
      authError ||
      schemasError ||
      categoriesError ||
      iconsError ||
      credentialDefinitionsError ||
      credentialsError ||
      proofsError ||
      invitationsError ||
      requestsError ||
      usersError;

    if (!error) return;

    if (error?.code === NetworkingServiceErrorType.cancelled) {
      return;
    }

    notify("error")({
      message: error.userMessage(),
      autoHideDuration: 6000,
      onClose: dispatchClearErrors,
    });
  }, [
    authError,
    schemasError,
    categoriesError,
    iconsError,
    credentialDefinitionsError,
    credentialsError,
    proofsError,
    invitationsError,
    requestsError,
    usersError,
  ]);

  return null;
};
